import moment from 'moment';
// example = 18-Jan-2022
export const simpleFormatDate = (input) => {
    return input ? moment(input).format('DD-MMM-YYYY') : '';
};
// example = 18 Jan 2022
export const simpleFormatDateWoHiven = (input) => {
    return input ? moment(input).format('DD MMM YYYY') : '';
};
// example = 20-10-2021 09:38:19
export const formatDateTime = (input) => {
    if (input) {
        return moment(input).local().format('DD-MM-YYYY hh:mm:ss');
    }
    else {
        return '';
    }
};
// example = 26 Mar 2022 17:38
export const formatUTCtoLocalDateTimeTwentyFourHours = (input) => {
    if (input) {
        return moment.utc(input).local().format('DD MMM YYYY, HH:mm');
    }
    else {
        return '';
    }
};
export const formatUTCtoLocalDateTimeTwentyFourHoursToSecond = (input) => {
    if (input) {
        return moment.utc(input).local().format('DD MMM YYYY, HH:mm:ss');
    }
    else {
        return '';
    }
};
// example = 2022-12-20
export const formatInternationalDate = (input) => {
    if (input) {
        return moment(input).format('YYYY-MM-DD');
    }
    else {
        return '';
    }
};
// example = Feb 08,2022 11:16 AM from UTC "2022-02-08T04:16:13.3333333"
export const formatUTCtoLocalDateTimeMeridiem = (input) => {
    if (input) {
        return moment.utc(input).local().format('MMM DD, YYYY hh:mm A');
    }
    else {
        return '';
    }
};
// example = 22/02/2022 09:46 AM
export const formatSlashDateTimeMeridiem = (input) => {
    if (input) {
        return moment(input).format('DD/MM/YYYY hh:mm A');
    }
    else {
        return '';
    }
};
// example = 22/02/2022
export const formatSlashDate = (input) => {
    if (input) {
        return moment(input).format('DD/MM/YYYY');
    }
    else {
        return '';
    }
};
// example = 02/22/2022
export const formatInternationalSlashDate = (input) => {
    if (input) {
        return moment(input).format('MM/DD/YYYY');
    }
    else {
        return '';
    }
};
// example = 24:00 to UTC
export const formattime24 = (input) => {
    if (input) {
        return moment.utc(input).local().format('HH:mm');
    }
    else {
        return '';
    }
};
// example = 24:00
export const formatDateString = (input) => {
    if (input) {
        return moment(input).format('MMMM DD, YYYY');
    }
    else {
        return '';
    }
};
export const formatDate = (input, format) => {
    return input ? moment(input).format(format) : '';
};
export const calculateDateOverdue = (input) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const leftOver = new Date(input) - new Date();
    const overdue = Math.round(Math.floor(leftOver) / (1000 * 60 * 60 * 24));
    if (overdue < 0) {
        return '';
    }
    return overdue;
};
export const isValidDate = (input) => {
    return moment(input, moment.ISO_8601, true).isValid();
};
export const dateToUTC = (input) => {
    return Date.UTC(input.getUTCFullYear(), input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds());
};
// 04/14/2022, 12:00:00 AM
export const datetimeformatBE = (input) => {
    return moment(input).format('MM/DD/YYYY, hh:mm:ss A');
};
// 11 Mar 2022 19:35:40
export const dpaDateTimeFormat = (input) => {
    if (input) {
        return moment(input).format('DD MMM YYYY HH:mm:ss');
    }
    else {
        return '';
    }
};
export const formatDateTimeUTC = (input) => {
    if (moment(input).format('DD MMM YYYY') === '01 Jan 1900' ||
        moment(input).format('DD MMM YYYY') === '01 Jan 0001') {
        return '';
    }
    return moment.utc(input).local().format('DD MMM YYYY HH:mm:ss');
};
export const formatDateUTC = (input) => {
    if (moment(input).format('DD MMM YYYY') === '01 Jan 1900' ||
        moment(input).format('DD MMM YYYY') === '01 Jan 0001') {
        return '';
    }
    return moment.utc(input).local().format('DD MMM YYYY');
};
// example mining format save date 22Feb2022
export const formatDateDDMMMYY = (input) => {
    if (input) {
        return moment.utc(input).local().format('DDMMMYY');
    }
    else {
        return '';
    }
};
export const substractDate = (input, pointer) => {
    if (input) {
        return moment(new Date())
            .subtract(input, pointer)
            .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        })
            .toDate();
    }
    else {
        return '';
    }
};
export const addDate = (input, pointer) => {
    if (input) {
        return moment(new Date())
            .add(input, pointer)
            .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        })
            .toDate();
    }
    else {
        return '';
    }
};
export const formatDateZeroTimestamp = (input) => {
    if (input) {
        return moment(input)
            .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        })
            .toDate();
    }
    else {
        return '';
    }
};
export const formatDateToUtc = (date) => {
    if (!date)
        return '';
    return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
};
export const getUtcDifferentWithLocal = () => {
    // Get the timezone offset in minutes for the local timezone
    const timezoneOffsetMinutes = new Date().getTimezoneOffset();
    // Convert the timezone offset to hours and invert the sign to get the difference
    const diffHours = (timezoneOffsetMinutes / 60) * -1;
    return diffHours;
};
export const addingLocalFromUtc = (value) => {
    if (!value)
        return '';
    const date = new Date(value);
    date.setHours(date.getHours() + getUtcDifferentWithLocal());
    return date.toISOString();
};
